import { axiosInstance as axios } from 'Api';
import { handlingResponse } from 'Utility/globalMethods';
import { Config } from 'Constants/config_env';
/* eslint-disable global-require */
if (ISMOCK) {
	require('Mocks/groups/groups');
}

export async function groupList(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: `group/list`,
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
export async function groupFind(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: 'group/find',
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
export async function groupDetail(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: 'group/detail',
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
export async function groupDelete(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: 'group/delete',
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
export async function groupCreate(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: 'group/create',
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
export async function groupUpdate(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: 'group/update',
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
// @generator api:method
